import merge from 'lodash/merge';
import { originalQueryKeyFactory } from '../search/state/originalQueryKeyFactory';
import { getPageName } from './pageName';
import { UserCustomWindow } from '../user/user.types';

/* eslint-disable camelcase */
interface CustomWindow extends Window {
  current_user?: UserCustomWindow['current_user'];
  gtag?: Function;
  arret_infos: any;
}
/* eslint-enable camelcase */

declare let window: CustomWindow;

const eventsExcludedFromGA = [
  'Account CookieBannerShown',
  'Decision PopoverMoreLikeThisAppeared',
  'Search AutocompleteItemSelected',
  'Account ModalRestrictedAppeared',
  'Account CookieBannerClosed',
  'Decision SummaryItemClicked',
];

function send(eventName: string, data: Object) {
  const http = new XMLHttpRequest();
  http.open('POST', '/track', true);
  http.setRequestHeader('Content-type', 'application/json; charset=utf-8');
  const pageName = getPageName();
  if (!pageName) {
    if (window.Rollbar) {
      window.Rollbar.error(
        `Doctrine internal error: missing page name for ${window.location} on event ${eventName}`,
      );
    }
  }
  http.send(
    JSON.stringify({
      event: eventName,
      data: {
        ...data,
        pageName,
        ab_tests_buckets:
          window.current_user && window.current_user.ab_tests_buckets,
      },
    }),
  );
  const eventParts = eventName.split(' ');
  if (window.gtag && !eventsExcludedFromGA.includes(eventName)) {
    window.gtag('event', eventParts[1], {
      event_category: eventParts[0],
      event_label: eventParts[1],
    });
  }
}

/* eslint-disable camelcase */
function getEnhancedData(
  data: { reportOriginalQueryKey?: string; original_query_key?: string } = {},
  /* eslint-enable camelcase */
) {
  const enhancedData = { ...data };
  const originalQueryKey = originalQueryKeyFactory.get();
  if (originalQueryKey && enhancedData.reportOriginalQueryKey) {
    enhancedData.original_query_key = originalQueryKey;
  }
  delete enhancedData.reportOriginalQueryKey;
  return enhancedData;
}

function sendAnalytics(
  eventName: string,
  data?: { [s: string]: any },
  isDecision?: boolean,
) {
  const dataEnhanced = getEnhancedData(data);

  if (isDecision) return sendAnalyticsDecision(eventName, dataEnhanced);

  return send(eventName, dataEnhanced);
}

// wrapper only on page decision
function sendAnalyticsDecision(event: string, data?: Object) {
  send(event, merge(window.arret_infos, data));
}

const fakeSend = () => false;

export const doctrineAnalytics =
  process.env.NODE_ENV === 'test' ? fakeSend : sendAnalytics;
export const doctrineAnalyticsDecision =
  process.env.NODE_ENV === 'test' ? fakeSend : sendAnalyticsDecision;
